import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { TABLE_HEADER_BACKGROUND_COLOR } from '../../../constants/colors';
import { PopupTypeEnum } from '../../../enums/popupTypeEnum';
import { useTranslation } from 'react-i18next';

interface Props {
  value: PopupTypeEnum;
  onChange: (newValue: PopupTypeEnum) => void;
}

export default function TabPanelComponent({ value, onChange }: Props) {
  const { t } = useTranslation('global');

  return (
    <Box sx={{ width: '100%', backgroundColor: TABLE_HEADER_BACKGROUND_COLOR }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={(e: any, newValue: PopupTypeEnum) => {
            onChange(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab
            label={t('popup_page.Landing Page')}
            value={PopupTypeEnum.LANDING_PAGE}
            sx={{ textTransform: 'none' }}
          />
          <Tab
            label={t('popup_page.Delivery')}
            value={PopupTypeEnum.DELIVERY}
            sx={{ textTransform: 'none' }}
          />
          {/* <Tab
            label={t('popup_page.Coupon')}
            value={PopupTypeEnum.COUPON}
            sx={{ textTransform: 'none' }}
          />
          <Tab
            label={t('popup_page.Promotion')}
            value={PopupTypeEnum.PROMOTION}
            sx={{ textTransform: 'none' }}
          />
          <Tab
            label={t('popup_page.Category')}
            value={PopupTypeEnum.CATEGORY}
            sx={{ textTransform: 'none' }}
          />
           <Tab
            label={t('popup_page.Product')}
            value={PopupTypeEnum.PRODUCT}
            sx={{ textTransform: 'none' }}
          />
           <Tab
            label={t('popup_page.Merchant')}
            value={PopupTypeEnum.MERCHANT}
            sx={{ textTransform: 'none' }}
          /> */}
        </Tabs>
      </Box>
    </Box>
  );
}
